import assign from 'lodash/assign';
import uiRouter from '@uirouter/angularjs';

import { HttpPrefixDirective } from 'components/httpPrefix/httpPrefix.directive';

import template from './addLinkModal.html';

export const RedactorAddLinkModalModule = angular
    .module('app.components.redactor.redactorAddLinkModal', [
        'ngMaterial',
        uiRouter,
        HttpPrefixDirective
    ]).component('redactorAddLinkModal', {
        template,
        controller: class AddLinkModalController {
            constructor(
                $scope,
                $mdDialog,
                $state
            ) {
                'ngInject';

                assign(this, {
                    link: {},
                    $scope,
                    $mdDialog,
                    $state
                });
            }

            $onInit() {
                this.stateName = this.$state.current.name;
            }

            confirm() {
                this.$mdDialog.hide(this.link);
            }

            cancel() {
                this.$mdDialog.cancel('cancel');
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/redactor/components/addLinkModal.component.js